import { Col } from 'styled-bootstrap-grid'
import { DropdownV5 } from '@pinchenterprisesnpm/friday-ui'
import GenericTooltip from '../../GenericTooltip'
import { ColumnType, OffsetType } from '../utils'
import { Label, RequiredLabel } from './style'

type DropdownData = {
  value: number
  label: string
}

type FormDropdownProps = {
  label?: string
  value: ReadonlyArray<DropdownData> | null
  name: string
  handleChange: (field: string, value: any) => void
  dropdownOptions: Array<DropdownData>
  requiredLabel?: string
  tooltipMessage?: string
  errorMessage?: string
  fieldTouched?: boolean
  lgFieldColumns?: ColumnType
  mdFieldColumns?: ColumnType
  labelColumns?: ColumnType
  fieldOffset?: OffsetType
  isDisabled?: boolean
  placeholder?: string
  menuPlacement?: 'top' | 'auto' | 'bottom'
}

const FormMultiSelect = (props: FormDropdownProps) => {
  const {
    label,
    value,
    name,
    dropdownOptions,
    handleChange,
    errorMessage,
    fieldTouched,
    tooltipMessage,
    requiredLabel,
    lgFieldColumns,
    mdFieldColumns,
    labelColumns,
    fieldOffset,
    isDisabled,
    placeholder,
    menuPlacement = 'auto',
  } = props
  return (
    <>
      {label && (
        <Col lg={labelColumns}>
          <Label>{label}</Label>
          {tooltipMessage && <GenericTooltip message={tooltipMessage} />}
          {requiredLabel && <RequiredLabel>{requiredLabel}</RequiredLabel>}
        </Col>
      )}
      <Col lg={lgFieldColumns} md={mdFieldColumns} offset={fieldOffset} mdOffset={fieldOffset}>
        <DropdownV5
          options={dropdownOptions}
          isMulti
          isSearchable
          isClearable
          isOutlined
          placeholder={placeholder}
          rounded={false}
          isDisabled={isDisabled}
          value={value}
          onChange={(value) => {
            handleChange(name, value)
          }}
          size='large'
          errorMessage={errorMessage && fieldTouched ? errorMessage : undefined}
          menuPlacement={menuPlacement}
        />
      </Col>
    </>
  )
}

FormMultiSelect.defaultProps = {
  label: '',
  errorMessage: '',
  fieldTouched: false,
  requiredLabel: '',
  lgFieldColumns: 9,
  mdFieldColumns: 9,
  labelColumns: 2,
  fieldOffset: 0,
  isDisabled: false,
}

export default FormMultiSelect
